module.exports = __webpack_public_path__ + "img/contested-check-jeff-carlisle.d1ffb47e.jpg";